import { useEffect, useState } from "react";
import CountdownClock from "./countdownClock";
import Title from "./title";
import { CountdownClockWACProps } from "./types";
import { getCountdownClockData } from "../../dreamCar-service";
import CountdownClockLoader from "./countdownClockLoader";

const CountdownClockWAC = ({ title, description, competitionType }: CountdownClockWACProps) => {
  const [competitionEndDate, setCompetitionEndDate] = useState<Date>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const response = await getCountdownClockData(competitionType);
        const endDateTime = await response.json();
        setCompetitionEndDate(new Date(endDateTime));
      } catch (error) {
        console.error(`Error while fetching the count down clock data- ${JSON.stringify(error)}`);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  return isLoading ? (
    <CountdownClockLoader />
  ) : (
    <article className="xs:hidden sm:block">
      <Title {...{ title, description }} />
      <CountdownClock EndDateTime={competitionEndDate} />
    </article>
  );
};

export default CountdownClockWAC;
